import React from "react";
interface IProps {
  buttonText?: string;
  onClick;
  className?: string;
  disabled?: boolean;
}
const ItemizeButton: React.FC<IProps> = ({
  buttonText = "",
  onClick,
  className = "",
  disabled = false,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      type={"button"}
      className={` ${
        disabled
          ? `cursor-not-allowed text-white opacity-50 bg-secondary py-1 px-3 rounded-full text-xs font-medius`
          : `text-white bg-secondary py-1 px-3 rounded-full text-xs font-medium`
      } ${className}`}
    >
      <p className="font-semibold"> {buttonText}</p>
    </button>
  );
};

export default ItemizeButton;
